import React from 'react';
import moment from 'moment';
import { getNumberFormat, colorCategory } from 'utils/helpers';
import CategoryIcons from 'library/categoryIcons';
import CheckInput from 'screens/components/basic/CheckInput';
import NoDataMsg from 'library/noData';
import Button from 'screens/components/basic/Button';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ResponsiveContainer, PieChart, Pie, Label, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from "recharts";

const Body = ({ inventorySummary, productVelocity, priceTracker, priceTrackerGraphData, endDate, beginDate, priceTrackerCheck, thclist, cbdlist, THCTrackerCheck, CBDTrackerCheck, downloadPrices, downloadTHC, downloadCBD, TrackProductChange }) => (
    <div>
        {

            inventorySummary.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div className="clearfix">
                    <div className="text-center list_header">
                        {beginDate ?
                            <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment(endDate).format('MMMM Do, YYYY')}</p>
                            : ""}
                    </div>

                    <div className="col-lg-12 mt-2">
                        {(productVelocity.firstPO && productVelocity.firstPO.length > 0) && <h3>First Purchase Order: {productVelocity.firstPO}</h3>}
                        {(productVelocity.firstOrder && productVelocity.firstOrder.length > 0) && <h3>First Sale: {productVelocity.firstOrder}</h3>}
                    </div>

                    <div className="col-lg-12 mt-2" >
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart width={730} height={250} data={inventorySummary.map(x => ({ date: x.changedDate, quantity: x.quantity }))}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />

                                <YAxis label={{ value: 'Inventory', angle: -90, position: 'insideLeft' }} />
                                <Tooltip />

                                <Bar dataKey="quantity" fill="#82ca9d" />
                            </BarChart>

                        </ResponsiveContainer>
                    </div>

                    <div className="col-lg-12 mb-2">
                        <h3>Total Ordered Quantity (current range): {productVelocity.boughtInRange}</h3>
                        <h3>Total Quantity Sold     (current range): {productVelocity.soldInRange}</h3>
                    </div>

                    <div className="row m-0">
                        <div className="col-lg-12">
                            <p>Please note that only a maximum of 100 records are shown in the following tables.</p>
                            <br />
                        </div>

                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Order #</th>
                                        <th>Date</th>
                                        <th>Quantity</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productVelocity.oPitems ? productVelocity.oPitems.sort((a, b) => a.date > b.date ? 1 : -1).map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.id}</td>
                                                    <td>{item.date}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.status}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>

                        </div>
                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>PO #</th>
                                        <th>Date</th>
                                        <th>Quantity</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productVelocity.pOitems ? productVelocity.pOitems.sort((a, b) => a.date > b.date ? 1 : -1).map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.id}</td>
                                                    <td>{item.date}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.status}</td>
                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>

                        </div>

                        <div className="col-lg-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>New Quantity</th>
                                        <th>Old Quantity</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productVelocity.manualChanges ? productVelocity.manualChanges.sort((a, b) => a.date > b.date ? 1 : -1).map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.date}</td>
                                                    <td>{item.newQuantity}</td>
                                                    <td>{item.previousQuantity}</td>

                                                </tr>
                                            )
                                        }) : <p></p>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br />
                    <br />

                    {TrackProductChange && <div>

                        <CheckInput name="InventoryLevelPriceHistory" text="Display Price History" />

                        {priceTrackerCheck && priceTrackerGraphData.length > 0 && priceTracker.length > 0 ?
                            <div>
                                <Button
                                    type="DownloadButton"
                                    className="pull-right mt-1 ml-1 mr-2"
                                    name={"InventoryLevelReport2"}
                                    label="Download Price History"
                                    onTouchTap={downloadPrices}
                                />
                                <div className="col-lg-12 mt-2" >
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart width={730} height={250} data={priceTrackerGraphData.map(x => ({ date: x.date, price: x.price }))}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="date" />
                                            <YAxis label={{ value: 'Price', angle: -90, position: 'insideLeft' }} />
                                            <Tooltip />

                                            <Bar dataKey="price" fill="#82ca9d" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                                <div className="row m-0">
                                    <div className="col-lg-4">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Price</th>
                                                    <th>Employee</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    priceTracker ? priceTracker.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{moment(item.createdDate).format("YYYY-MM-DD hh:mm")}</td>
                                                                <td>{item.newPrice}</td>
                                                                <td>{item.employee}</td>

                                                            </tr>
                                                        )
                                                    }) : <p></p>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {priceTrackerCheck && priceTrackerGraphData.length == 0 && priceTracker.length == 0 ? <p>No Price data</p> : ""}

                        <br />
                        <br />
                        <CheckInput name="InventoryLevelTHCHistory" text="Display Product THC History" />

                        {THCTrackerCheck && thclist.length > 0 ?
                            <div>
                                <Button
                                    type="DownloadButton"
                                    className="pull-right mt-1 ml-1 mr-2"
                                    name={"InventoryLevelReport3"}
                                    label="Download THC History"
                                    onTouchTap={downloadTHC}
                                />


                                <div className="row m-0">
                                    <div className="col-lg-4">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>THC</th>
                                                    <th>Employee</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    thclist ? thclist.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{moment(item.date).format("YYYY-MM-DD hh:mm")}</td>
                                                                <td>{item.thc}</td>
                                                                <td>{item.employee}</td>

                                                            </tr>
                                                        )
                                                    }) : <p></p>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {THCTrackerCheck && thclist.length == 0 ? <p>No THC data</p> : ""}

                        <br />
                        <br />
                        <CheckInput name="InventoryLevelCBDHistory" text="Display Product CBD History" />

                        {CBDTrackerCheck && cbdlist.length > 0 ?
                            <div>
                                <Button
                                    type="DownloadButton"
                                    className="pull-right mt-1 ml-1 mr-2"
                                    name={"InventoryLevelReport4"}
                                    label="Download CBD History"
                                    onTouchTap={downloadCBD}
                                />

                                <div className="row m-0">
                                    <div className="col-lg-4">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>CBD</th>
                                                    <th>Employee</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    cbdlist ? cbdlist.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{moment(item.date).format("YYYY-MM-DD hh:mm")}</td>
                                                                <td>{item.cbd}</td>
                                                                <td>{item.employee}</td>

                                                            </tr>
                                                        )
                                                    }) : <p></p>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {CBDTrackerCheck && cbdlist.length == 0 ? <p>No CBD data</p> : ""}
                    </div>}
                </div>
        }
    </div>
);
export default Body;